module.exports = __webpack_public_path__ + "img/foot2.27956bd0.png";